import useBrandCustomProfile, { useBrandCustomProfileForm } from '@hooks/useBrandCustomProfile'
import useRoles from '@hooks/useRoles'

import type { BrandCustomProfileModel } from '@models/types'

const useCreateBrandCustomProfile = (initBrandCustomProfile: BrandCustomProfileModel) => {
  const { filteredRoles } = useRoles({ performHttpRequests: true })

  const filteredOfficeAdminAndAgent = filteredRoles.filter(
    filteredRole => ['office_administrator', 'agent'].includes(filteredRole.key),
  )

  const brandCustomProfileFormPayload = useBrandCustomProfileForm(
    {
      ...initBrandCustomProfile,
    },
    {
      entity: initBrandCustomProfile,
      validateOn: 'change',
      requiredFields: [
        { key: 'brand_id' },
        { key: 'role_id' },
        { key: 'title' },
        { key: 'profile_type' },
      ],
    },
  )

  const { entityState, handlers, saveEnabled } = brandCustomProfileFormPayload

  const {
    brandCustomProfile,
    callbacks: { manageBrandCustomProfileUserPermissions },
  } = useBrandCustomProfile(entityState)

  return {
    brandCustomProfile,
    brandCustomProfileFormPayload,
    callbacks: { manageBrandCustomProfileUserPermissions },
    entityState,
    filteredRoles: filteredOfficeAdminAndAgent,
    handlers,
    saveEnabled,
  }
}

export default useCreateBrandCustomProfile
